// Template191: Bangkok - Wat Arun (Día 1)
// Idéntico a PageWatArun.jsx de guia-bangkok. borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template191 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText =
		page?.texts?.[0]?.content ?? "Día 1: Templos imprescindibles";
	const intro = page?.texts?.[1]?.content;
	const titleOverlay = page?.texts?.[2]?.content ?? "Wat Arun";
	const watArunTitle = page?.texts?.[3]?.content ?? "WAT ARUN";
	const watArunBody = page?.texts?.[4]?.content;
	const llegarTitle = page?.texts?.[5]?.content ?? "Cómo llegar a Wat Arun";
	const llegarBody = page?.texts?.[6]?.content;
	const tipText = page?.texts?.[7]?.content;
	const consejoText = page?.texts?.[8]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const detalleImage = getImageSrc("detalle");
	const atardecerImage = getImageSrc("atardecer");
	const stickerUrl = getCanvasImageUrl("sticker");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{!isSmallScreen && logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: 32,
							textAlign: "center",
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{ width: 90, position: "absolute", bottom: 50, left: 25 }}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", position: "relative" }}>
				{intro && (
					<Box sx={{ fontSize: "13px", color: "#333", margin: 0, padding: 0 }}>
						{intro}
					</Box>
				)}
			</Box>

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 12px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					marginTop: 1,
				}}
			>
				<Box sx={{ display: "flex", gap: 2, position: "relative" }}>
					{detalleImage && (
						<Box sx={{ width: "40%" }}>
							<Box
								component="img"
								src={detalleImage}
								alt=""
								sx={{
									width: "100%",
									height: 100,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						</Box>
					)}
					{sabiasQue.length > 0 && (
						<>
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? 52 : 40,
									left: isSmallScreen ? "32%" : "34%",
									zIndex: 30,
								}}
							>
								<SabiasQue
									icono={sabiasQue[0]?.icono ?? "🌅"}
									texto={sabiasQue[0]?.texto ?? ""}
								/>
							</Box>
							{sabiasQue[1] && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? 12 : 0,
										left: isSmallScreen ? "32%" : "34%",
										zIndex: 20,
									}}
								>
									<SabiasQue
										icono={sabiasQue[1]?.icono ?? "✨"}
										texto={sabiasQue[1]?.texto ?? ""}
									/>
								</Box>
							)}
						</>
					)}
					<Box sx={{ width: "60%" }}>
						<Box component="h3" sx={h3}>
							{watArunTitle}
						</Box>
						{watArunBody && (
							<Box component="p" sx={p}>
								{watArunBody}
							</Box>
						)}
					</Box>
				</Box>

				{(llegarTitle || llegarBody) && (
					<Box
						data-block-id="text-3"
						sx={{
							backgroundColor: "#FFF3CD",
							border: "3px solid #E8A838",
							borderRadius: "12px",
							padding: "8px 20px",
							fontSize: "12px",
							color: "#333",
							width: "100%",
						}}
					>
						{llegarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: "13px",
									fontWeight: 700,
									display: "flex",
									alignItems: "center",
									gap: 0.75,
									color: "#E8A838",
									textTransform: "uppercase",
								}}
							>
								{llegarTitle}
							</Box>
						)}
						{llegarBody && (
							<Box
								sx={{
									...p,
									"& ul": { paddingLeft: 2.5, margin: 0, marginTop: 0.5 },
									"& li": { marginBottom: 0.25 },
								}}
								dangerouslySetInnerHTML={{ __html: llegarBody }}
							/>
						)}
					</Box>
				)}

				<Box
					data-block-id="text-4"
					sx={{
						display: "flex",
						gap: 2,
						justifyContent: "flex-end",
						width: "100%",
						position: "relative",
						marginTop: isSmallScreen ? 6 : 2.5,
						marginBottom: isSmallScreen ? 2.5 : 0,
					}}
				>
					{atardecerImage && (
						<Box
							component="img"
							src={atardecerImage}
							alt=""
							sx={{
								width: 110,
								position: "absolute",
								bottom: isSmallScreen ? 70 : -70,
								left: isSmallScreen ? -25 : -10,
							}}
						/>
					)}
					{tipText && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? "auto" : 10,
								top: isSmallScreen ? -50 : "auto",
								left: isSmallScreen ? 65 : 18,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 16px 0px",
								padding: "10px 12px",
								fontSize: 11,
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: isSmallScreen ? 220 : 160,
							}}
						>
							{tipText}
						</Box>
					)}
					{consejoText && (
						<Box
							sx={{
								backgroundColor: "#d4edda",
								border: "3px solid #28a745",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: "12px",
								color: "#333",
								marginTop: isSmallScreen ? 5 : 0,
								width: isSmallScreen ? "100%" : "70%",
							}}
						>
							<Box component="p" sx={p}>
								{consejoText}
							</Box>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template191.thumbnail = "/images/template-1.png";
export default Template191;
